import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { useQueryRequest } from './QueryRequestProvider'
import { getLogsConsultaIdAtendimento } from './_requests'
import { LogAtendimentoView } from './_models'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '_metronic/helpers'

const QueryResponseContext = createResponseContext<LogAtendimentoView>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state } = useQueryRequest()
  const { id } = useParams<{ id: string }>()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.LOGS_CONSULTA_DETALHE, id, query],
    () => getLogsConsultaIdAtendimento(query, Number(id)),
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: Boolean(id) }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
